module.exports = __webpack_public_path__ + "static/media/zeroe02.dbba09ad.jpg";